import React from "react";
import { getDisabledStateFromLifecycleStatuses } from "../../utilities/lifecycleStatus";
import { LabeledDropDownSelect } from "../DropDownSelect";

const SmartFileMatterSelector = ({
	smartFileAssociatedMatter,
	allMattersInLexWorkplace,
	handleChange,
}) => {
	const {
		matterName,
		matterLifecycleStatus,
		userHasAccessToMatter,
		matterID,
	} = smartFileAssociatedMatter;

	const matterLifecycleStatusObject = getDisabledStateFromLifecycleStatuses({
		matterLifecycleStatus,
	});

	return (
		<div>
			<div style={{ maxWidth: "440px", marginTop: 16 }}>
				<LabeledDropDownSelect
					label="Matter"
					name="selectedMatter"
					isAsync
					options={
						allMattersInLexWorkplace
							? allMattersInLexWorkplace.map((m) => {
									return {
										label: m.name,
										value: m.id,
										isDisabled: m.isDeleted !== 0,
									};
								})
							: []
					}
					defaultValue={[
						{
							label: matterName,
							value: matterID,
						},
					]}
					handler={handleChange}
				/>
			</div>
			{matterLifecycleStatusObject.IN_TRASH ? (
				<div className="inlineErrorIndicator">
					This Matter is in the trash, so emails cannot be filed to
					it. Restore this Matter from the trash, remove this
					Email/Matter association, OR change which Matter is
					associated with this email address.
				</div>
			) : matterLifecycleStatusObject.IN_ARCHIVE ? (
				<div className="inlineErrorIndicator">
					This Matter is in the archive, so emails cannot be filed to
					it. Restore this Matter from the archive, remove this
					Email/Matter association, OR change which Matter is
					associated with this email address.
				</div>
			) : null}
			{userHasAccessToMatter ? null : (
				<div className="inlineErrorIndicator">
					You do not have sufficient permissions to file emails to
					this Matter. Speak to your firm administrator to request
					permissions, remove this Email/Matter association, OR change
					which Matter is associated with this email address.
				</div>
			)}
		</div>
	);
};

export { SmartFileMatterSelector };
